var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"},nativeOn:{"click":function($event){return _vm.toggleMap.apply(null, arguments)}}},[_c('p',{attrs:{"id":"brand"}},[_vm._v("CREATING HOME")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }